import { render, staticRenderFns } from "./card-preview.vue?vue&type=template&id=b2248c74"
import script from "./card-preview.vue?vue&type=script&lang=js"
export * from "./card-preview.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports